/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs */

const en_svc_rag_knowledge_assistants_eval_title4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evals`)
};

const ar_svc_rag_knowledge_assistants_eval_title4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقييمات`)
};

const bn_svc_rag_knowledge_assistants_eval_title4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইভাল`)
};

const de_svc_rag_knowledge_assistants_eval_title4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswertungen`)
};

const es_svc_rag_knowledge_assistants_eval_title4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluaciones`)
};

const fr_svc_rag_knowledge_assistants_eval_title4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évaluations`)
};

const pt_svc_rag_knowledge_assistants_eval_title4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliações`)
};

const zh_svc_rag_knowledge_assistants_eval_title4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评估`)
};

const tr_svc_rag_knowledge_assistants_eval_title4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değerlendirmeler`)
};

const ru_svc_rag_knowledge_assistants_eval_title4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценки`)
};

const pl_svc_rag_knowledge_assistants_eval_title4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wartości`)
};

/**
* | output |
* | --- |
* | "Evals" |
*
* @param {Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_eval_title4 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Eval_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_eval_title4(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_eval_title4(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_eval_title4(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_eval_title4(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_eval_title4(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_eval_title4(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_eval_title4(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_eval_title4(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_eval_title4(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_eval_title4(inputs)
	return en_svc_rag_knowledge_assistants_eval_title4(inputs)
});
export { svc_rag_knowledge_assistants_eval_title4 as "svc_rag-knowledge-assistants_EVAL_title" }